// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xb2n6","questions":"styles_questions__29j2w","footer":"styles_footer__1EDyH"};